"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurNarrative() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="our-narrative" className="dark bg-background text-foreground relative overflow-hidden py-24 lg:py-32">
      {}
      <div className="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 select-none" aria-hidden="true">
        <span className="text-[30vw] font-black leading-none tracking-tighter text-transparent opacity-10 [-webkit-text-stroke:2px_var(--color-foreground)]">
          AXE
        </span>
      </div>

      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-12 lg:items-center">
          
          {}
          <div ref={textRef} className={`lg:col-span-5 flex flex-col justify-center transition-all duration-1000 ease-out ${isTextVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
            <div className="mb-6 inline-flex items-center gap-2">
              <span className="h-px w-8 bg-primary"></span>
              <span className="text-sm font-medium uppercase tracking-widest text-primary">
                Our History
              </span>
            </div>
            
            <h2 className="mb-8 text-4xl font-bold tracking-tight sm:text-5xl lg:text-6xl">
              Precision <br className="hidden lg:block" />
              <span className="text-muted-foreground">Modernism.</span>
            </h2>
            
            <div className="space-y-6 text-lg text-muted-foreground">
              <p>
                Founded on the principle that data without direction is just noise, Axebox Media emerged to cut through the clutter of the digital marketing landscape. We recognized a critical gap in the home improvement sector: the need for high-intent, actionable prospects rather than just volume.
              </p>
              <p>
                Our dual-model approach was engineered to solve this. By combining the immediate impact of real-time branded campaigns with the strategic, cost-effective nature of aged leads, we provide our partners with unparalleled scalability. We don't just generate leads; we architect growth systems for kitchen remodeling, bathroom remodeling, and solar enterprises.
              </p>
            </div>

            <div className="mt-10">
              <Link to="/OurExpertisePage" className="group inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-wider text-foreground transition-colors hover:text-primary">
                Explore Our Expertise
                <ArrowRight className="size-4 transition-transform group-hover:translate-x-1" />
              </Link>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`lg:col-span-7 relative transition-all duration-1000 delay-200 ease-out ${isImageVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
            <div className="relative aspect-[4/5] w-full max-w-lg mx-auto lg:ml-auto lg:mr-0">
              {}
              <div className="absolute inset-0 overflow-hidden bg-muted">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586938/img/axebox_modern_office_bw.png" alt="Modern office environment at Axebox Media" className="h-full w-full object-cover grayscale transition-transform duration-700 hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-background/80 to-transparent"></div>
              </div>

              {}
              <div className="absolute -bottom-12 -left-12 hidden w-2/3 overflow-hidden border-8 border-background bg-muted shadow-2xl md:block">
                <div className="aspect-square w-full">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586938/img/axebox_strategy_meeting_bw.png" alt="Axebox Media team strategy meeting" className="h-full w-full object-cover grayscale transition-transform duration-700 hover:scale-105" />
                </div>
              </div>
              
              {}
              <div className="absolute -right-6 top-12 -z-10 h-full w-full border border-border/50"></div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}